import { useSelector } from 'react-redux';
import Button  from '@mui/material/Button';
import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser';
import { Buffer } from "buffer";
import axios from 'axios';

const FileOpen = props => {
  const data = props.data;
  const token = useSelector (state => state.auth.token );
  const type = useSelector( state => state.type.typeIs );

  const getAdjunto = async () => {
   return await axios.get(`api/noticias/adjunto/${data.id}`, { 
      headers: {
         'authorization':  `Bearer ${token}`
      }, 
   })
    }

    const handleFile = async () => {
        let adjunto, tipoAdjunto, nombreAdjunto;
        if (type == "plan") {
            const url = new URL(`${window.location.origin}/Home/PlanAtraqueById?id=${data.id}`)
            window.open(url.href)
            return
        }

       if (type === "news") {
          const response = (await getAdjunto()).data;
          adjunto = response.adjunto
          tipoAdjunto = response.tipoAdjunto
          nombreAjunto = response.nombreAjunto
       }
       const b = Buffer.from(adjunto, 'base64');

       const file = new Blob(
          [b], 
          {type: tipoAdjunto,
          filename: nombreAjunto});
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL) 
   }                  
 
  return (
     <Button onClick={handleFile}><OpenInBrowserIcon/></Button>
  )
}

export default FileOpen;